import React from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import Page from 'src/model/page';
import { Link } from 'react-router';

// Components
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import { ContentChannelDetail } from 'components/SharedComponents/content/content-channel-detail';
import { ContentVideo } from 'components/SharedComponents/content/content-video';

export class SearchResultCard extends React.Component {
    constructor(props) {
        super(props);
    }

    mixPanelSearchCard(eventType) {
        if (!this.props.searchId || !eventType) {
            return;
        }
        mixpanelTracker.track(`${mixpanelTracker.searchPage}-${mixpanelTracker.searchResultClicked}`, {
            search_id: this.props.searchId,
            type: eventType
        });
    }

    contentClickHandler(e) {
        if (e.target.className === 'content-channel-detail__channel-title') {
            return;
        }
        this.mixPanelSearchCard(`${mixpanelTracker.resultCardWatchNow}`);
    }

    channelInfoClickHandler() {
        this.mixPanelSearchCard(`${mixpanelTracker.resultCardChannel}`);
    }

    getSearchCardlayout(contentVideoProps, contentChannelDetailProps) {
        return (
            <div className="search-result-card__onclick" onClick={this.contentClickHandler.bind(this)}>
                <ContentVideo {...contentVideoProps} />
                <ContentChannelDetail {...contentChannelDetailProps} />
            </div>
        );
    }

    displaySearchResultCard() {
        const { result, searchId } = this.props;
        const searchIdQuery = searchId ? `&search_id=${searchId}` : '';
        if (result.metadata && result.metadata.channelInfo) {
            const channelInfo = result.metadata.channelInfo;
            let cardThumbnail = null;
            if (result.metadata.customThumbnailUrl) {
                cardThumbnail = result.metadata.customThumbnailUrl;
            } else if (result.metadata.defaultThumbnailUrl) {
                cardThumbnail = result.metadata.defaultThumbnailUrl;
            }

            const contentVideoProps = {
                contentDuration: result.metadata.duration,
                contentThumbnail: cardThumbnail,
                cardType: 'searchCard',
                isFetching: this.props.isFetching
            };
            const contentChannelDetailProps = {
                channelKey: channelInfo.channelKey,
                channelTitle: channelInfo.channelTitle,
                channelLogo: channelInfo.channelLogo,
                contentTitle: result.metadata.title,
                contentDescription: result.metadata.desc,
                contentCategory: result.metadata.category,
                contentPublishDate: result.metadata.createTime,
                channelInfoClickHandler: this.channelInfoClickHandler.bind(this, result),
                isFetching: this.props.isFetching
            };

            return (<div
              className="search-result-card animated fadeIn"
              data-channelkey={`${channelInfo.channelKey}`}
              data-contentkey={`${result.metadata.contentId}`}
            >
            {channelInfo.channelKey && result.metadata.contentId ?
                <Link
                  to={{pathname: `/channel/${channelInfo.channelKey}/recording/${result.metadata.contentId}/watch`,
                  search: `?source=${Page.SEARCH_RESULTS}${searchIdQuery}`}}
                > {this.getSearchCardlayout(contentVideoProps, contentChannelDetailProps)} </Link> :
                this.getSearchCardlayout(contentVideoProps, contentChannelDetailProps)}
            </div>);
        }
        return null;
    }
    render() {
        return this.displaySearchResultCard();
    }
}

SearchResultCard.propTypes = {
    t: PropTypes.func,
    result: PropTypes.object,
    searchId: PropTypes.string,
    isFetching: PropTypes.number
};

export default (translate(['translation'])(SearchResultCard));



// WEBPACK FOOTER //
// ./src/components/search/search-result-card.js